import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import HeaderWithActions, {
  CustomButtonProps,
} from '../../../../../lib/designSystem/HeaderWithActions';
import CenteredCircularProgress from '../../../../../lib/designSystem/CircularProgress';
import EnhancedTable from '../../../../../lib/designSystem/Table';
import { getRelatedBusinesses } from '../../../../../lib/api/business';
import CreateRelationDialog from './components/CreateRelationDialog';
import ConfirmDeleteDialog from './components/ConfirmDeleteDialog';
const RelatedBusinesses = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [relatedBusinesses, setRelatedBusinesses] = useState<any>([]);
  const [openCreateRelationDialog, setOpenCreateRelationDialog] =
    useState(false);
  const [businessToDelete, setBusinessToDelete] = useState<any>(null);
  const [openConfirmDeleteDialog, setOpenConfirmDeleteDialog] = useState(false);
  const { id } = useParams<{
    id: string;
    businessId: string;
    page: string;
  }>();

  const fetchRelatedBusinesses = async () => {
    if (!id) {
      alert('No se ha encontrado el id de la empresa');
      return;
    }
    const response = await getRelatedBusinesses(dispatch, id);
    setRelatedBusinesses(response);
  };

  const setUp = async () => {
    setLoading(true);
    await fetchRelatedBusinesses();
    setLoading(false);
  };

  const onCloseCreateRelationDialog = async () => {
    setOpenCreateRelationDialog(false);
    await setUp();
  };

  const onCloseConfirmDeleteDialog = async () => {
    setOpenConfirmDeleteDialog(false);
    setBusinessToDelete(null);
    await setUp();
  };

  const buttons: CustomButtonProps[] = [
    {
      name: 'Crear',
      action: () => setOpenCreateRelationDialog(true),
      color: 'primary',
    },
  ];

  const handleDelete = async (identifier: string) => {
    const businessToIdentifier = relatedBusinesses.find(
      (business: any) => business.id === identifier,
    );
    if (!businessToIdentifier) {
      alert('No se ha encontrado la empresa');
      return;
    }
    setOpenConfirmDeleteDialog(true);
    setBusinessToDelete(businessToIdentifier.id);
  };

  useEffect(() => {
    setUp();
  }, []);

  const headers = [
    { key: 'businessName', label: 'Nombre' },
    { key: 'businessIdentifier', label: 'Rut' },
  ];

  const actions = [
    {
      action: handleDelete,
      actionLabel: 'Eliminar',
    },
  ];
  if (loading) return <CenteredCircularProgress relative />;

  return (
    <div>
      <HeaderWithActions
        variant="body1"
        subHeader
        buttons={buttons}
        title="Acá podrás ir sumando las empresas que están relacionadas a esta empresa."
      />
      <EnhancedTable
        dataHeaders={headers}
        data={relatedBusinesses}
        rowsPerPageDefault={100}
        actions={actions}
      />
      {loading && <CenteredCircularProgress relative />}
      {openCreateRelationDialog && (
        <CreateRelationDialog
          open={openCreateRelationDialog}
          onClose={onCloseCreateRelationDialog}
          businessFromIdentifier={id as string}
        />
      )}
      {openConfirmDeleteDialog && (
        <ConfirmDeleteDialog
          open={openConfirmDeleteDialog}
          onClose={() => onCloseConfirmDeleteDialog()}
          businessToIdentifier={businessToDelete}
          businessFromIdentifier={id as string}
        />
      )}
    </div>
  );
};

export default RelatedBusinesses;
